import { Component, Host, h, JSX, Prop } from '@stencil/core'
import { Manufacturer } from '@rdss/client'
import { Distributor, ProductLines } from '../../types' // todo

@Component({
    tag: 'zr-manufacturer',
    styleUrl: 'zr-manufacturer.scss',
    scoped: true,
})

/**
 * ZooRoyal manufacturer component.
 */
export class ZrManufacturer {

    /**
     * The current Manufacturer.
     */
    @Prop() manufacturer: Manufacturer

    /**
     * Value of the productLines.
     */
    @Prop() productLines: ProductLines

    /**
     * Distributor for product security information.
     */
    @Prop() distributor: Distributor | null = null

    /**
     * Label for the product security information headline.
     */
    @Prop() labelDistributor = 'Herstellerinformationen'

    /**
     * Label for the product sortiment.
     */
    @Prop() labelProductSortiment = 'Produkt-Sortiment'

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render(): JSX.Element {
        return (
            <Host>
                <div class="zr-manufacturer__wrapper">
                    <div class="zr-manufacturer__image">
                        <a href={this.manufacturer.link} title={this.manufacturer.name}>
                            <img src={this.manufacturer.coverFile} alt={this.manufacturer.name}/>
                        </a>
                    </div>
                    {this.productLines &&
                        <div class="zr-manufacturer__product-lines">
                            <h4 class="zr-manufacturer__product-lines-headline">
                                {this.manufacturer.name} {this.labelProductSortiment}:
                            </h4>

                            <ul class="zr-manufacturer__product-lines-list">
                                {this.productLines.map(productLine => (
                                    <li>
                                        <a class="zr-manufacturer__product-lines-link" href={productLine.url}
                                            title={productLine.title}>
                                            {productLine.title}
                                        </a>
                                    </li>
                                ))}
                            </ul>

                        </div>
                    }
                </div>
                <div class="zr-manufacturer__wrapper">
                    {(this.distributor?.name || this.distributor?.address || this.distributor?.contactOption) &&
                        <div class="zr-manufacturer__distributor">
                            <h4 class="zr-manufacturer__distributor-headline">{this.labelDistributor}:</h4>
                            <p class="zr-manufacturer__distributor-text">
                                <span innerHTML={this.distributor.name} />
                                <span innerHTML={this.distributor.address} />
                                <span innerHTML={this.distributor.contactOption} />
                            </p>
                        </div>}
                </div>
            </Host>
        )
    }
}
